export class SlidePanelState {
    isOpen: boolean = false;
}
